import http from "@web-app/utils/http";

export interface LiveKitTokenResponse {
  roomName: string;
  token: string;
}

export interface GetLiveKitTokenPayload {
  conversationId: string;
}

export const getLiveKitToken = (payload: GetLiveKitTokenPayload) => {
  return http
    .post<LiveKitTokenResponse>("/chat/livekit/token", payload)
    .then((response) => response.data);
};
